import React from 'react';
import SimpleTextInfo, { SimpleTextInfoProps } from './SimpleTextInfo';
import { toLocalFormattedString, toUTCFormattedString } from '../../utils/dateTransform';

const SimpleDateInfo: React.FC<SimpleDateInfoProps> = (props) => {
	const { title, value, showInvalid, ...rest } = props;
	const formattedValue = toLocalFormattedString(value as string, showInvalid);
	const formattedTitle = title || toUTCFormattedString(value as string, showInvalid);

	return <SimpleTextInfo value={formattedValue} title={formattedTitle} {...rest} />;
};

type SimpleDateInfoProps = SimpleTextInfoProps & {
	showInvalid?: boolean | string;
};

export default SimpleDateInfo;
